import React from 'react';
import { shape, arrayOf, string, number } from 'prop-types';
import StyledLabel from '../styled-label';
import componentEnhance from '../../lib/component-enhance';

const namespace = 'credits-offer-value';

const CreditsOfferValue = ({ contentRows }) => (
  <ul className={`${namespace}__container`}>
    {contentRows.map(({ label }) => (
      <li key={label.text} className={`${namespace}__container__item`}>
        <StyledLabel
          as="p"
          color={label.color}
          font_size={label.font_size}
          font_family={label.font_family}
          text={componentEnhance.jsx(label.text, label.values)}
        />
      </li>
    ))}
  </ul>
);

CreditsOfferValue.propTypes = {
  contentRows: arrayOf(
    shape({
      label: shape({
        text: string.isRequired,
        color: string.isRequired,
        font_family: string.isRequired,
        font_size: string.isRequired,
        margin: shape({
          bottom: number.isRequired,
          top: number.isRequired,
          left: number.isRequired,
          right: number.isRequired,
        }),
      }).isRequired,
    }).isRequired,
  ),
};

export default CreditsOfferValue;
